import {createReducer, on} from "@ngrx/store";
import {templateEntityAdapter as EntityAdapter, initialState} from "./template.state";
import {TemplateActions as Actions} from "./template.actions";

export const templateReducer = createReducer(
  initialState,

  on(Actions.load, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId
  })),

  on(Actions.loadSuccess, (state, {entities, correlationId}) => {
      if (!correlationId)
        return EntityAdapter.setAll(entities, {
          ...state,
          isLoading: false,
          error: undefined,
        });

      return EntityAdapter.setAll(entities, {
        ...state,
        isLoading: false,
        error: undefined,
        correlationId,
        history: [...state.history, {correlationId, payload: entities}]
      });
    }
  ),

  on(Actions.loadRelatedTemplates, (state, {correlationId}) => ({
    ...state,
    isLoadingCurrent: true,
    correlationId,
  })),

  on(Actions.loadRelatedTemplatesSuccess, (
    state,
    {resultWithPageInfo, correlationId}
  ) => {
    if (!correlationId)
      return({
        ...state,
        isLoadingCurrent: false,
        error: undefined,
        currentRelatedEntities: resultWithPageInfo.entities,
        currentRelatedEntitiesCurrentPage: resultWithPageInfo.pageInfo,
      });

    return ({
      ...state,
      isLoadingCurrent: false,
      error: undefined,
      currentRelatedEntities: resultWithPageInfo.entities,
      history: [...state.history, {correlationId, payload: resultWithPageInfo}],
      currentRelatedEntitiesCurrentPage: resultWithPageInfo.pageInfo,
    });
  }),

  on(Actions.loadFailure, (state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),

  on(Actions.create, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.createSuccess, (state, {entity, correlationId}) => {
      if (!correlationId)
        return EntityAdapter.addOne(entity, {
          ...state,
          isLoading: false,
          error: undefined,
        });

      return EntityAdapter.addOne(entity, {
        ...state,
        isLoading: false,
        error: undefined,
        correlationId,
        history: [...state.history, {correlationId, payload: entity}]
      });
    }
  ),

  on(Actions.createFailure, (state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),

  on(Actions.createMany, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.createManySuccess, (state, {entities, correlationId}) => {
    if (!correlationId)
      return EntityAdapter.addMany(entities, {
        ...state,
        isLoading: false,
        error: undefined,
      });

    return EntityAdapter.addMany(entities, {
      ...state,
      isLoading: false,
      error: undefined,
      correlationId,
      history: [...state.history, {correlationId, payload: entities}],
    });
  }),

  on(Actions.createManyFailure, (state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),


  on(Actions.update, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.updateSuccess, (state, {entity, correlationId}) => {
      if (!correlationId)
        return EntityAdapter.updateOne(
          {id: entity.id, changes: entity},
          {
            ...state,
            isLoading: false,
            error: undefined,
          });

      return EntityAdapter.updateOne(
        {id: entity.id, changes: entity},
        {
          ...state,
          isLoading: false,
          error: undefined,
          correlationId,
          history: [...state.history, {correlationId, payload: entity}]
        });
    }
  ),

  on(Actions.updateFailure, (state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),

  on(Actions.updateMany, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.updateManySuccess, (state, {entities, correlationId}) => {
    if (!correlationId)
      return EntityAdapter.updateMany(
        entities.map(entity => ({id: entity.id, changes: entity})),
        {
          ...state,
          isLoading: false,
          error: undefined,
        });

    return EntityAdapter.updateMany(
      entities.map(entity => ({id: entity.id, changes: entity})),
      {
        ...state,
        isLoading: false,
        error: undefined,
        correlationId,
        history: [...state.history, {correlationId, payload: entities}],
      });
  }),

  on(Actions.updateManyFailure, (state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),

  on(Actions.remove, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.removeSuccess, (state, {entity, correlationId}) => {
    if (!correlationId)
      return EntityAdapter.removeOne(entity.id, {
        ...state,
        isLoading: false,
        error: undefined,
      });

    return EntityAdapter.removeOne(entity.id, {
      ...state,
      isLoading: false,
      error: undefined,
      correlationId,
      history: [...state.history, {correlationId, payload: entity}]
    });
  }),

  on(Actions.removeFailure, (state, {error, correlationId}) => {
    if (!correlationId)
      return {
        ...state,
        isLoading: false,
        error,
      };

    return {
      ...state,
      isLoading: false,
      error,
      correlationId,
      history: [...state.history, {correlationId, payload: error}]
    };
  }),

  on(Actions.removeMany, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.removeManySuccess, (state, {entityIds, correlationId}) => {
    if (!correlationId)
      return EntityAdapter.removeMany(entityIds, {
        ...state,
        isLoading: false,
        error: undefined,
      });

    return EntityAdapter.removeMany(entityIds, {
      ...state,
      isLoading: false,
      error: undefined,
      correlationId,
      history: [...state.history, {correlationId, payload: entityIds}]
    });
  }),

  on(Actions.removeManyFailure, (state, {error, correlationId}) => {
    if (!correlationId)
      return {
        ...state,
        isLoading: false,
        error,
      };

    return {
      ...state,
      isLoading: false,
      error,
      correlationId,
      history: [...state.history, {correlationId, payload: error}]
    };
  }),

  on(Actions.loadPage, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.loadPageSuccess, (state, {resultWithPageInfo, correlationId}) => {
    if (!correlationId)
      return EntityAdapter.setAll(resultWithPageInfo.entities, {
        ...state,
        isLoading: false,
        error: undefined,
        currentPageEntities: resultWithPageInfo.entities.map(entity => entity.id),
        currentPage: resultWithPageInfo.pageInfo,
      });

    return EntityAdapter.setAll(resultWithPageInfo.entities, {
      ...state,
      isLoading: false,
      error: undefined,
      currentPageEntities: resultWithPageInfo.entities.map(entity => entity.id),
      currentPage: resultWithPageInfo.pageInfo,
      history: [...state.history, {correlationId, payload: resultWithPageInfo}],
    });
  }),

  on(Actions.loadPageFailure, (state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),

  on(Actions.setCurrentEntity, (state, {entity}) => ({
    ...state,
    currentEntity: entity,
  })),


  on(Actions.setCurrentEntityId, (state, { entityId }) => {
    // Update state only if entityId is different
    if (state.currentEntityId !== entityId) {
      return {
        ...state,
        currentEntityId: entityId,
      };
    }
    // Return the state as is if there's no change
    return state;
  }),

  on(Actions.deselectAll, (state) => ({ ...state, currentEntityIds: [] })),

  on(Actions.deselectEntities, (state, { entities }) => {
    // Assuming 'entities' is an array of entities, extract their IDs.
    const entityIdsToRemove = entities.map(entity => entity.id);

    // Use the EntityAdapter to remove the entities from the state
    const newState = EntityAdapter.removeMany(entityIdsToRemove, state);

    // Filter out the deselected entity IDs from currentEntityIds
    const updatedCurrentEntityIds = state.currentEntityIds?.filter(id => !entityIdsToRemove.includes(id));

    return {
      ...newState, // newState already incorporates the changes made by removeMany
      currentEntityIds: updatedCurrentEntityIds, // Overwrite currentEntityIds with the filtered list
    };
  }),


  on(Actions.selectEntities, (state, { entities }) => {
    // Use the EntityAdapter to set the entities in the state
    const newState = EntityAdapter.setMany(entities, state);

    // Extract the IDs from the entities
    const entityIds = entities.map(entity => entity.id);

    return {
      ...newState,
      currentEntityIds: entityIds
    };
  }),

  on(Actions.selectEntity, (state, { entityIds }) => {
    // Create a new Set from the existing state to ensure uniqueness
    const currentEntityIdsSet = new Set(state.currentEntityIds);

    // Add each new entityId to the Set if it doesn't already exist in the state
    entityIds.forEach(entityId => {
      if (!currentEntityIdsSet.has(entityId)) {
        currentEntityIdsSet.add(entityId);
      }
    });

    // Convert the Set back to an array for the new state
    const newCurrentEntityIds = Array.from(currentEntityIdsSet);

    return {
      ...state,
      currentEntityIds: newCurrentEntityIds
    };
  }),

  on(Actions.deselectEntities, (state, { entities }) => {
    // Create a Set from the currentEntityIds for easy removal
    const updatedEntityIdsSet = new Set(state.currentEntityIds);

    // Remove each entityId that needs to be deselected
    entities.forEach(entity => {
      updatedEntityIdsSet.delete(entity.id);
    });

    // Convert the Set back to an array for the new state
    const updatedCurrentEntityIds = Array.from(updatedEntityIdsSet);

    return {
      ...state,
      currentEntityIds: updatedCurrentEntityIds,
      // Set currentEntityId to undefined if it's in the deselected list
      currentEntityId: entities.some(entity => entity.id === state.currentEntityId) ? undefined : state.currentEntityId,
    };
  }),


  on(Actions.updateInStore, Actions.createInStore, (state, {entity}) => {
      // Replace in place to preserve order — appending the updated entity to the
      // end causes downstream lists (e.g. WizardArticleListComponent) to re-render
      // the just-edited row at a different position, which reads as the row
      // "jumping" when the user opens a placement and clicks save. New entities
      // (no matching tempId) still get appended.
      const idx = state.entitiesTemporary.findIndex(y => y.tempId === entity.tempId);
      const next = [...state.entitiesTemporary];
      if (idx >= 0) next[idx] = entity;
      else next.push(entity);
      return {
        ...state,
        entitiesTemporary: next
      };
    }
  ),

  on(Actions.removeInStore, (state, {entity}) => {
      return {
        ...state,
        entitiesTemporary:
          [
            ...state.entitiesTemporary.filter(y => y.tempId !== entity.tempId),
          ]
      };
    }
  ),

  on(Actions.clearStore, (state) => ({
    ...state,
    entitiesTemporary: [],
  })),

  on(Actions.clearUnsavedByCategory, (state, { productCategoryId }) => ({
    ...state,
    entitiesTemporary: state.entitiesTemporary.filter(
      t => t.productCategoryId !== productCategoryId
    ),
  })),

  on(Actions.clearProductCategoryId, (state) => ({
    ...state,
    currentProductCategoryId: undefined,
  })),

  on(Actions.setProductCategoryId, (state, {productCategoryId}) => ({
    ...state,
    currentProductCategoryId: productCategoryId,
  })),

  on(Actions.setPaginationSettings, (state, {page}) => ({
    ...state,
    currentPage: { totalCount: state.currentPage?.totalCount, page},
  })),

  on(Actions.clearPage, (state, {}) => ({
    ...state,
    currentPageEntities: initialState.currentPageEntities,
    currentPage: initialState.currentPage,
  })),

  // Draft handlers
  on(Actions.saveDraft, Actions.loadDraft, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.saveDraftSuccess, (state, {entity, correlationId}) => {
    if (!correlationId)
      return EntityAdapter.upsertOne(entity, {
        ...state,
        isLoading: false,
        error: undefined,
      });

    return EntityAdapter.upsertOne(entity, {
      ...state,
      isLoading: false,
      error: undefined,
      correlationId,
      history: [...state.history, {correlationId, payload: entity}]
    });
  }),

  on(Actions.loadDraftSuccess, (state, {entity, correlationId}) => {
    // entity can be null if no draft exists
    if (!correlationId) {
      if (entity) {
        return EntityAdapter.upsertOne(entity, {
          ...state,
          isLoading: false,
          error: undefined,
        });
      }
      return {
        ...state,
        isLoading: false,
        error: undefined,
      };
    }

    if (entity) {
      return EntityAdapter.upsertOne(entity, {
        ...state,
        isLoading: false,
        error: undefined,
        correlationId,
        history: [...state.history, {correlationId, payload: entity}]
      });
    }
    // No draft found - use null as payload
    return {
      ...state,
      isLoading: false,
      error: undefined,
      correlationId,
      history: [...state.history, {correlationId, payload: null}]
    };
  }),

  on(Actions.saveDraftFailure, Actions.loadDraftFailure, (state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),
);
